"use client";

import React from "react";
import { Droplets, Wrench, CircleAlert, Wind, Thermometer, Fan } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Netzwerksicherheit",
  description: "Hochmoderne Firewalls und Intrusion Detection Systeme zum Schutz Ihrer kritischen Infrastruktur vor unbefugtem Zugriff.",
  icon: Droplets
}, {
  title: "Infrastrukturberatung",
  description: "Strategische Planung und Optimierung Ihrer IT-Landschaft für maximale Ausfallsicherheit und technologische Exzellenz.",
  icon: Wrench
}, {
  title: "Incident Response",
  description: "Schnelle Reaktion und Forensik bei Sicherheitsvorfällen, um Schäden zu minimieren und Systeme sicher wiederherzustellen.",
  icon: CircleAlert
}, {
  title: "Cloud Security",
  description: "Ganzheitliche Absicherung Ihrer Cloud-Umgebungen und hybriden Architekturen nach höchsten Industriestandards.",
  icon: Wind
}, {
  title: "Vulnerability Management",
  description: "Kontinuierliche Identifizierung und Behebung von Schwachstellen, bevor diese von Angreifern ausgenutzt werden können.",
  icon: Thermometer
}, {
  title: "Compliance & Audit",
  description: "Umfassende Überprüfung Ihrer Systeme auf Einhaltung gesetzlicher und regulatorischer Sicherheitsanforderungen.",
  icon: Fan
}];
function ServiceCard({
  service,
  index
}: {
  service: (typeof services)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  const Icon = service.icon;
  return <div data-index={index} ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
    transitionDelay: `${index * 100}ms`
  }}>
      <Card className="group flex h-full flex-col items-center border border-border/40 bg-card/50 backdrop-blur-md text-center transition-all duration-300 hover:border-primary/50 hover:shadow-2xl hover:shadow-primary/10">
        <CardHeader className="flex flex-col items-center pb-4 pt-8">
          <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-xl bg-primary/10 text-primary transition-transform duration-500 group-hover:-translate-y-2 group-hover:scale-110 group-hover:shadow-[0_0_20px_rgba(0,255,255,0.3)]">
            <Icon className="h-10 w-10" strokeWidth={1.5} />
          </div>
          <CardTitle className="font-default text-xl font-bold tracking-tight text-foreground">
            {service.title}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <CardDescription className="font-sans text-base leading-relaxed text-muted-foreground">
            {service.description}
          </CardDescription>
        </CardContent>
      </Card>
    </div>;
}
export default function OurPlumbingSpecialties() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="223013" id="unser-leistungsportfolio" className="bg-background text-foreground py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`mx-auto max-w-2xl text-center transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl font-extrabold tracking-tighter text-foreground sm:text-5xl">
            Unser Leistungsportfolio
          </h2>
          <p className="mt-4 font-sans text-lg leading-8 text-muted-foreground">
            Von präziser Netzwerkanalyse bis hin zu komplexen Enterprise-Sicherheitsstrategien – unsere Experten liefern kompromisslose Lösungen für Ihre digitale Souveränität.
          </p>
        </div>

        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-2 lg:max-w-none lg:grid-cols-3 lg:gap-8">
          {services.map((service, index) => <ServiceCard key={service.title} service={service} index={index} />)}
        </div>
      </div>
    </section>;
}